const ProductDisplayHeaderTotalCount = ({
  totalCount,
}: {
  totalCount: number;
}) => {
  return (
    <div className="flex h-32 items-center justify-between">
      <div className="text-description typo-paragraph200-regular">
        <span className="text-paragraph typo-paragraph200-semibold">
          {totalCount.toLocaleString()}
        </span>
        개의 결과
      </div>
    </div>
  );
};

export default ProductDisplayHeaderTotalCount;
